import type { LedgerRole, Member } from './types.ts'

/** Five different products, not five checkboxes - a role picker always shows the consequence beside it. */
export const ASSIGNABLE_ROLES: readonly LedgerRole[] = [
  'OWNER',
  'PARTNER',
  'OBSERVER',
  'AGGREGATES_VIEWER',
  'CONTRIBUTOR',
]

/**
 * The server refuses to demote or remove the last OWNER. Computed here, not read from the
 * wire - `LedgerMemberResponse` carries no such flag - so the control can be withheld
 * rather than offered and then rejected.
 */
export function isLastOwner(members: readonly Member[], subject: string): boolean {
  const member = members.find((candidate) => candidate.subject === subject)
  if (member === undefined || member.role !== 'OWNER') return false
  return members.filter((candidate) => candidate.role === 'OWNER').length <= 1
}
